import Vue from 'vue'
import VueRouter from 'vue-router'
import Ezplay from '../views/Ezplay'
import FarmRunningStatus from '../views/FarmRunningStatus'
import Ylsfj from '../views/Ylsfj2'
import Ylsfj2 from '../views/Ylsfj3'

Vue.use(VueRouter)

const routes = [
  {
    path: '/ezplay',
    name: 'ezplay',
    component: Ezplay
  },
  {
    path: '/farmRunningStatus',
    name: 'farmRunningStatus',
    component: FarmRunningStatus
  },
  // {
  //   path: '/Ylsfj',
  //   name: 'Ylsfj',
  //   component: Ylsfj
  // },
  // {
  //   path: '/Ylsfj2',
  //   name: 'Ylsfj2',
  //   component: Ylsfj2
  // },
  // {
  //   path: '/about',
  //   name: 'About',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  // }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
